/**
 * Reusable team header bar for match flow nodes.
 */

import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

type TeamHeaderProps = {
  teamName: string;
  isMyTeam?: boolean;
  isPicking?: boolean;
  rightContent?: ReactNode;
  className?: string;
};

export function TeamHeader({
  teamName,
  isMyTeam = false,
  isPicking = false,
  rightContent,
  className,
}: TeamHeaderProps) {
  return (
    <div
      className={cn(
        "px-4 py-3 border-b flex items-center gap-2",
        isPicking
          ? "border-brand-500/20 bg-brand-500/[0.06]"
          : isMyTeam
            ? "border-brand-500/15 bg-brand-500/[0.04]"
            : "border-surface-600/30",
        className,
      )}
    >
      <span
        className={cn(
          "font-display text-sm font-semibold uppercase tracking-wider",
          isPicking || isMyTeam ? "text-text-primary" : "text-text-secondary",
        )}
      >
        {teamName}
      </span>
      {isMyTeam && (
        <span className="text-2xs uppercase tracking-wider text-brand-400 font-medium">(you)</span>
      )}
      <div className="flex-1" />
      {rightContent}
    </div>
  );
}
